import React from 'react'

import Toggle from 'components/Toggle'
import { ToolTip } from '@driftt/tide-core-legacy'

import './style.styl'

const Option = ({ title, children, checked, onClick, toggleDisabled = false, tooltipText = '' }) =>
  <div className="playbook-sequence-option">
    <span>{title}</span>
    <div className="playbook-sequence-option-content">
      <div className="playbook-sequence-option-description">{children}</div>
      <ToolTip hover={tooltipText} component={tooltipText} flow={'up'}>
        <Toggle onClick={onClick} checked={checked} disabled={toggleDisabled}/>
      </ToolTip>
    </div>
  </div>

const SequenceOptions = ({
  onSmartSendingClick,
  onWeekdaysOnlyClick,
  onUnenrollOnReplyClick,
  onUnenrollOnReplyByDomainClick,
  weekdaysOnly,
  smartSending,
  unenrollOnReply,
  isOutboundSequencePlaybook,
  unenrollOnReplyByDomain
}) =>
  <div className="playbook-sequence-options">
    <div className="playbook-title-header">
      <h2>Advanced sending options</h2>
      <p>Improve your open rates by optimizing how and when your emails send.</p>
    </div>
    <div className="playbook-card">
      <Option title="Smart Sending" checked={smartSending} onClick={onSmartSendingClick}>
        <p>
          Drift knows the timezone of the person you are emailing. Use smart sending to send emails
          when your prospect is most likely to open it.
        </p>
      </Option>
      <Option title="Avoid weekends and holidays" checked={weekdaysOnly} onClick={onWeekdaysOnlyClick}>
        <p>
          Drift won&rsquo;t send your emails on weekends (Saturday + Sunday) or Federal US holidays.{' '}
          <a href="https://help.drift.com/article/advanced-sequence-sending-options/" target="_blank">Learn more</a>
        </p>
      </Option>
      <Option title="Unenroll contacts on reply"
        checked={unenrollOnReply || isOutboundSequencePlaybook}
        onClick={onUnenrollOnReplyClick}
        toggleDisabled={isOutboundSequencePlaybook}
        tooltipText={isOutboundSequencePlaybook && 'Unenroll on reply is always on for sales sequences sent through Gmail'}>
        <p>
          {isOutboundSequencePlaybook ? `Drift will unenroll contacts from receiving additional emails in a sequence once they reply to an email.` :  `Drift can unenroll contacts from receiving addtional emails in a sequence once they reply to an email` }
        </p>
      </Option>
      <Option title="Unenroll same domain contacts on reply"
        checked={unenrollOnReplyByDomain}
        onClick={onUnenrollOnReplyByDomainClick} >
        <p>
         When a contact replies to your email Drift can unenroll all contacts with the same domain from the sequence. The sender must have Gmail connected here to track replies.
        </p>
      </Option>
    </div>
  </div>

export default SequenceOptions



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SequenceOptions/component.js